// cad_route : "terms/1"   //권한을 확인하고 싶은 route (cad_route)
// action_type : "조회" "삭제" "수정"   //권한에서의 하는 action (cad_name)

import Api from '@/api'; // 실제 경로에 맞게 조정
export const checkAccessPermission = (accessRoute) => {
    let params = {
        cadRoute: accessRoute,
        actionType: '조회',
    }
    try {
        return Api.$auth.checkPermission(params).then(res => {
            return res.success;
        });
    } catch (e) {
        console.log(e)
        return false;

    }
}
export const checkPermission = (accessRoute,action) => {
    let params = {
        cadRoute: accessRoute,
        actionType: action,
    }
    try {
        return Api.$auth.checkPermission(params).then(res => {
            return res.success;
        });
    } catch (e) {
        return false;

    }
}
